import axios from 'axios';
import { BasicStructure } from '../Interfaces';
import { getLocationEndpoint } from '../Endpoints';
import { getDefaultHeaders } from '../Utils';

export const getLocationStates = async (token: string, managementId: string) => {
    try{
        const defaultHeaders = getDefaultHeaders(token, managementId, undefined, {"Type": 1, "ParentCode": null}, "filtering");
        const {data, status} = await axios.get(getLocationEndpoint, defaultHeaders);
        if (status === 200 && data?.Ok){
            const result:BasicStructure[] = data.Data.filter((x: BasicStructure) => ["ATLANTICO", "BOLIVAR"].includes(x.Code!));
            return result;
        }

        return [];
    }
    catch {
        return [];
    }
}

export const getLocationCities = async (parentCode: string, token: string, managementId: string) => {
    try{
        const {data, status} = await axios.get(getLocationEndpoint, 
                                            getDefaultHeaders(token, 
                                            managementId, 
                                            undefined, 
                                            {"Type": 2, "ParentCode": `${parentCode}`}, "filtering"));
        if (status === 200 && data?.Ok){
            const result:BasicStructure[] = data.Data;
            return result;
        }

        return [];
    }
    catch {
        return [];
    }
}